import { TextAndImageContainer } from './text-and-image.styles';

const TextAndImage = ({
    img, 
    title, 
    title2, 
    text2, 
    text, 
    txtL
 }) => {

    if(!txtL) {
        return (
            <TextAndImageContainer>
                <span className='image-box' style={{
                    backgroundImage: `url(${img})`,
                }}></span>
                <span className="text-box">
                    <span className='text'>
                        <h5>{title}</h5>
                        <p>{text}</p>
                        <h5>{title2}</h5>
                        <p className='p-bottom'>{text2}</p>
                    </span>
                </span>
            </TextAndImageContainer>
        )
    } else {
        return (
            <TextAndImageContainer>
                <span className="text-box">
                    <span className='text'>
                        <h5>{title}</h5>
                        <p>{text}</p>
                        <h5>{title2}</h5>
                        <p className='p-bottom'>{text2}</p>
                    </span>
                </span>
                <span className='image-box' style={{
                    backgroundImage: `url(${img})`,
                }}></span>
            </TextAndImageContainer>
        )
    }
    
}

export default TextAndImage;